<my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>

    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading">{{ModelFor}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>

    <div class="col-sm-12" style="margin-top: 8px;">
        <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
            <div class="col-sm-4">
                <form #SearchReportConfigForm="ngForm" [formGroup]="FormSearchReportConfigForm" (ngSubmit)="onSearchReportConfig(SearchReportConfigForm.value);">
                    <div class="col-sm-2 text-left height-34">Search</div>
                    <div class="col-sm-6"><input class="form-control" formControlName="txtSearch" placeholder="Search here" name="txtSearch" type="text" value=""></div>
                    <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div>
                    <div class="col-sm-2"> <a title="Advance Search" data-toggle="modal" (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP"><i _ngcontent-efg-c1="" class="material-icons"> filter_list </i></a>
                    </div>
                </form>
            </div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-4">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-12" style="margin-top: 8px;">
        <div class=" col-sm-12 lefticonD paddingless" style="border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
            <label>Report Configuration </label>
        </div>
        <table width="100%" class="LMtable">
            <tr>
                <th>S.No.</th>
                <th>Report Name</th>
                <th>From User</th>
                <th>On Email</th>
                <th>Report Group</th>
                <th>Report Footer</th>
                <th>Action</th>
                <!--<th><input type="checkbox" id="CheckData" (change)="selectAll(this.pageNumber,$event);"></th> -->
            </tr>

            <!-- ============== Show Message / Loading ============== -->
            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>
            <!-- ==================================================== -->
            <ng-container *ngIf="this.MsgType == 0">
                <tr *ngFor="let mDtl of master | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index">
                    <td align="center">{{(pageNumber - 1) * 10 + i +1 }}</td>
                    <td> {{mDtl.RepName}} </td>
                    <td> {{mDtl.FromUser}} </td>
                    <td> {{mDtl.Email}} </td>
                    <td> {{mDtl.GroupName}} </td>
                    <td> {{mDtl.ReportFooter}} </td>
                    <td>

                        <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202018001') || this.RightsID.includes('202018021') ; then EditExpenseLink else EditExpense"></div>
                        <ng-template #EditExpenseLink>
                            <a target="_blank" routerLink="/configurereport/{{mDtl.RepID}}/{{mDtl.pRowID}}"><img src="assets/resources/images/edit.png"></a>
                        </ng-template>
                        <ng-template #EditExpense>
                            <a href="module/0"><img src="assets/resources/images/edit.png"></a>
                        </ng-template>

                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202018021') ; then DeleteExpenseLink else DeleteExpenseNotLink"></div>
                        <ng-template #DeleteExpenseLink>
                            <a title="Delete" (click)="DeleteRecord(mDtl.pRowID) ">
                                <!-- <img src="../../../assets/resources/images/delete.gif ">  -->
                                <span class="glyphicon glyphicon-trash"></span>
                            </a>
                        </ng-template>
                        <ng-template #DeleteExpenseNotLink>
                            <span class="glyphicon glyphicon-trash"></span>
                        </ng-template>
                    </td>
                    <!-- <td> <input type="checkbox" id="{{mDtl.ID}}" [checked]="isSelected[(pageNumber - 1) * 2 + i +1]"> {{(pageNumber - 1) * 2 + i +1 }}</td> -->


                </tr>
            </ng-container>
        </table>
        <br>

        <ng-container *ngIf="this.MsgType == 0">
            <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </ng-container>

    </div>


    <div><br>&nbsp;</div>

    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-3 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>
</my-content>

<my-content placeholder="main">

</my-content>
